module.exports = __webpack_public_path__ + "img/16.c69e087a.svg";